import { ALL_WIDGET_SETTING_KEY_STRINGS, NOT_SET } from '@/utils/UserSettings'

const widgetPreferences = {}
ALL_WIDGET_SETTING_KEY_STRINGS.forEach(key => {
  widgetPreferences[key] = NOT_SET
})

export default {
  userSettings: {
    contractFormSettings: {
      accountAutocompleteTags: [],
      destinationAutocompleteTags: [],
      fromAccountAutocompleteTags: []
    },
    activityFormSettings: {
      accountAutocompleteTags: []
    },
    tractFormSettings: {
      accountAutocompleteTags: [],
      defaultAccountAutocomplete: [],
      landOwnerAccountAutocomplete: [],
      driverAccountAutocomplete: [],
      haulerAccountAutocomplete: [],
      supplierAccountAutocomplete: [],
      tractContractAccountAutocomplete: [],
      tractDestinationAutocomplete: [],
      consultingForesterAccountAutocomplete: []
    },
    tableSettings: {
      tractCruiseHiddenColumns: [],
      tractCruiseHiddenColumnsMobile: [],
      ticketGridHiddenColumns: [],
      ticketGridHiddenColumnsMobile: [],
      byProductTicketGridHiddenColumns: [],
      transferTicketGridHiddenColumns: [],
      logYardSaleTicketGridHiddenColumns: [],
      tractGridHiddenColumns: [],
      tractGridHiddenColumnsMobile: [],
      dashboardLogCharts: [],
      dashboardBpCharts: [],
      dashboardOperationalCharts: [],
      dashboardBpOperationalCharts: [],
      productCostsDeliveredHiddenColumns: [],
      productCostsStumpageHiddenColumns: [],
      ticketCostsHiddenColumns: [],
      tractProductCostsHiddenColumns: [],
      logsContractGridHiddenColumns: [],
      byProductContractGridHiddenColumns: [],
      transfersContractGridHiddenColumns: [],
      contractFilterTypes: [],
      deckGridHiddenColumns: [],
      settlementsByContractHiddenColumns: [],
      settlementsByContractActivityHiddenColumns: [],
      settlementsByContractTicketHiddenColumns: [],
      settlementsByPayeeHiddenColumns: [],
      settlementsByPayeeActivityHiddenColumns: [],
      settlementsByPayeeTicketHiddenColumns: [],
      accrualsByPayeeHiddenColumns: [],
      accrualsByPayeeActivityHiddenColumns: [],
      accrualsByPayeeTicketHiddenColumns: [],
      byProductSettlementsByPayeeHiddenColumns: [],
      byProductSettlementsByPayeeActivityHiddenColumns: [],
      byProductSettlementsByPayeeTicketHiddenColumns: [],
      byProductReceivablesByPayerHiddenColumns: [],
      byProductReceivablesByPayerActivityHiddenColumns: [],
      byProductReceivablesByPayerTicketHiddenColumns: [],
      ticketRegisterTractSummaryHiddenColumns: [],
      ticketRegisterContractSummaryHiddenColumns: [],
      miscPaymentsAdvancesHiddenColumns: [],
      miscPaymentsTractPaymentsHiddenColumns: [],
      miscPaymentsAccountPaymentsHiddenColumns: []
    },
    dashboardSettings: {
      ...widgetPreferences,
      contractMode: 0
    },
    autocompleteSettings: {
      accountAutocompleteTagFilterModes: {}
    }
  },
  mutatedUserSettings: {
    contractFormSettings: {
      accountAutocompleteTags: [],
      destinationAutocompleteTags: [],
      fromAccountAutocompleteTags: []
    },
    activityFormSettings: {
      accountAutocompleteTags: []
    },
    tractFormSettings: {
      accountAutocompleteTags: [],
      defaultAccountAutocomplete: [],
      landOwnerAccountAutocomplete: [],
      driverAccountAutocomplete: [],
      haulerAccountAutocomplete: [],
      supplierAccountAutocomplete: [],
      tractContractAccountAutocomplete: [],
      tractDestinationAutocomplete: [],
      consultingForesterAccountAutocomplete: []
    },
    tableSettings: {
      tractCruiseHiddenColumns: [],
      tractCruiseHiddenColumnsMobile: [],
      ticketGridHiddenColumns: [],
      ticketGridHiddenColumnsMobile: [],
      byProductTicketGridHiddenColumns: [],
      transferTicketGridHiddenColumns: [],
      logYardSaleTicketGridHiddenColumns: [],
      tractGridHiddenColumns: [],
      tractGridHiddenColumnsMobile: [],
      dashboardLogCharts: [],
      dashboardBpCharts: [],
      dashboardOperationalCharts: [],
      dashboardBpOperationalCharts: [],
      dashboardHiddenSections: [],
      dashboardBpHiddenSections: [],
      productCostsDeliveredHiddenColumns: [],
      productCostsStumpageHiddenColumns: [],
      ticketCostsHiddenColumns: [],
      tractProductCostsHiddenColumns: [],
      logsContractGridHiddenColumns: [],
      byProductContractGridHiddenColumns: [],
      transfersContractGridHiddenColumns: [],
      contractFilterTypes: [],
      deckGridHiddenColumns: [],
      settlementsByContractHiddenColumns: [],
      settlementsByContractActivityHiddenColumns: [],
      settlementsByContractTicketHiddenColumns: [],
      settlementsByPayeeHiddenColumns: [],
      settlementsByPayeeActivityHiddenColumns: [],
      settlementsByPayeeTicketHiddenColumns: [],
      accrualsByPayeeHiddenColumns: [],
      accrualsByPayeeActivityHiddenColumns: [],
      accrualsByPayeeTicketHiddenColumns: [],
      byProductSettlementsByPayeeHiddenColumns: [],
      byProductSettlementsByPayeeActivityHiddenColumns: [],
      byProductSettlementsByPayeeTicketHiddenColumns: [],
      byProductReceivablesByPayerHiddenColumns: [],
      byProductReceivablesByPayerActivityHiddenColumns: [],
      byProductReceivablesByPayerTicketHiddenColumns: [],
      ticketRegisterTractSummaryHiddenColumns: [],
      ticketRegisterContractSummaryHiddenColumns: [],
      miscPaymentsAdvancesHiddenColumns: [],
      miscPaymentsTractPaymentsHiddenColumns: [],
      miscPaymentsAccountPaymentsHiddenColumns: []
    },
    dashboardSettings: {
      ...widgetPreferences,
      contractMode: 0
    },
    autocompleteSettings: {
      accountAutocompleteTagFilterModes: {}
    }
  }
}
